import React from 'react';

import { SVGComponentProps } from './svg.types';

const WhiteBoardLockSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="10"
        height="12"
        viewBox="0 0 10 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.33785 2.53854V5.53854C8.33785 5.66592 8.23447 5.76931 8.10708 5.76931C7.9797 5.76931 7.87631 5.66592 7.87631 5.53854V1.15392H6.4917V5.077C6.4917 5.20438 6.38832 5.30777 6.26093 5.30777C6.13355 5.30777 6.03016 5.20438 6.03016 5.077V0.692383H4.64555V5.077C4.64555 5.20438 4.54216 5.30777 4.41478 5.30777C4.28739 5.30777 4.18401 5.20438 4.18401 5.077V1.61546H2.79939V7.38469L1.86478 6.10577C1.58785 5.67885 1.04739 5.53577 0.651393 5.78038C0.256777 6.03054 0.158931 6.57608 0.432162 7.00161C0.432162 7.00161 1.93955 9.283 2.58201 10.2596C3.22447 11.2362 4.26524 12.0001 6.21155 12.0001C9.43401 12.0001 9.72247 9.51146 9.72247 8.76931C9.72247 8.02715 9.72247 2.53854 9.72247 2.53854H8.33785Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default WhiteBoardLockSVG;
